export default __webpack_public_path__ + "static/media/MarneSneaker.66b08d1d.jpg";